import ApexTree from "apextree";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
const CompanyTreeOrganizationOverView = ({
  departmentList = [],
  lang = "en",
  companyInformation = {},
  graphRef = null
}) => {
  // const [data, setData] = useState()
  const { i18n } = useTranslation();
  const containerRef = useRef(null)

  // const idKey = generateRandomString()
  const data = useMemo(() => {

    const renderTreeNodes = (nodes, lang) => {
      return nodes.map((node) => {
        console.log("node", node);
        return ({
          id: node.organizationId,
          name: i18n.language === "en"
            ? node.organizationNameEn
            : node.organizationName,
          children: [...renderTreeNodes(node.children, lang)]
        })
      }
      );
    };

    const data = {
      id: "root",
      name: i18n.language === "en"
        ? companyInformation.companyNameEn
        : companyInformation.companyName,
      children: [...renderTreeNodes(departmentList)]
    }

    return data;

    // setData(data)
  }, [companyInformation, departmentList, i18n.language])


  useEffect(() => {
    console.log("containerRef", containerRef);
    if (!containerRef?.current) return;
    // const data = {
    //   "id": "idA",
    //   "name": "A",
    //   "children": [
    //     {
    //       "id": "idB",
    //       "name": "B",
    //       "children": [
    //         {
    //           "id": "idC",
    //           "name": "C"
    //         },
    //         {
    //           "id": "idD",
    //           "name": "D"
    //         }
    //       ]
    //     }
    //   ]
    // };
    const options = {
      contentKey: 'id',
      width: "100%",
      height: "50vh",
      nodeWidth: 150,
      nodeHeight: 50,
      fontColor: '#2ba4dd',
      fontFamily: 'NotoSansThai',
      borderColor: 'transparent',
      borderWidth: 0,
      borderRadius: '3rem',
      childrenSpacing: 50,
      siblingSpacing: 30,
      direction: 'top',
      enableExpandCollapse: true,
      nodeTemplate: (content) => {
        // console.log("content", content, departmentList, );
        let data = departmentList.find(o => {
          function recursive(parent) {
            return parent.find(p => {
              if (p.organizationId == content) return p;
              if (p.children) return recursive(p.children)
            })
          }
          if (o.organizationId == content) return o;
          if (o.children) return recursive(o.children)
        });
        // id: "root",
        let name = ''
        if (content == 'root') {
          name = i18n.language === "en"
            ? companyInformation.companyNameEn
            : companyInformation.companyName
        }
        else {
          name = i18n.language === "en"
            ? data.organizationNameEn
            : data.organizationName
        }
        // let name = data?.name;
        return `<div  id=${data?.organizationId || 'root'} style=' display: flex;flex-direction: column;gap: 10px;justify-content: center;align-items: center;height: 100%;'>
        <div style="padding: 5px ;text-wrap: pretty;font-weight: bold; font-family: NotoSansThai; font-size: 14px">${name}</div>
       </div>`
      },
      canvasStyle: 'border: 1px solid black;background: #f6f6f6;',
      enableToolbar: true,
    };


    // const tree = new ApexTree(document.getElementById(idKey) , options);
    // if (graphRef?.current) {
    console.log("containerRef?.current", containerRef?.current);
    // containerRef?.current.rem
    const tree = new ApexTree(containerRef?.current, options);
    console.log("containerRef?.current", containerRef?.current?.children);
    const { children } = containerRef.current;
    while (children.length > 1) {
      containerRef.current.removeChild(children[0]);
    }
    console.log("data", data);

    tree?.render(data);
    // containerRef?.current?.addEventListener('click', (e) => {
    //   console.log("e", e);
    //   // containerRef?.current?.graph.changeLayout('left');
    // });
    // }

  }, [data]);

  const page = useCallback(
    () => {
      return <div ref={containerRef} />
    },
    [containerRef],
  )

  return (page());
};
export default CompanyTreeOrganizationOverView;
